import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { PRIVATE_ROUTES } from '../../routes'
import ReportingHubPage from './ReportingHubPage'
import ReportingProjectCapacityPage from './ReportingProjectCapacityPage'
import ReportingWorkloadPage from './ReportingWorkloadPage'

const ReportingRouter = () => (
    <Routes>
        <Route index element={<ReportingHubPage />} />
        <Route path="workload" element={<ReportingWorkloadPage />} />
        <Route
            path="project-capacity"
            element={<ReportingProjectCapacityPage />}
        />
        <Route
            path="*"
            element={<Navigate to={PRIVATE_ROUTES.reporting} replace />}
        />
    </Routes>
)

export default ReportingRouter
